import ShippingEstimator from './lib/ShippingEstimator';

export default ShippingEstimator;
